import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SuperI } from 'src/app/modelos/superintendecia.interface';
import { VariableI } from 'src/app/modelos/variable';
import { VarParamI } from 'src/app/modelos/VariableParametrica';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';

@Component({
  selector: 'app-superintendencia',
  templateUrl: './superintendencia.component.html',
  styleUrls: ['./superintendencia.component.css']
})
export class SuperintendenciaComponent implements OnInit {

  VariableParametrica : VarParamI;

  NuevaSuper : Boolean;
  SuperinList : VariableI[];
  Superintendencia : SuperI;

  EditId : BigInteger;
  EditCod : string;
  EditNom : string;
  SuperEditar : SuperI;

  NuevaSuperCod = new FormControl({value:'', disabled: true},[Validators.required]);
  NuevaSuperNom = new FormControl({value:'', disabled: true},[Validators.required]);

  page : number;

  constructor(
    private api:ApiService,
    private router:Router,
    private appService:AppServiceService,
    private toastr: ToastrService,
    private activerouter: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    let VarParamId = this.activerouter.snapshot.paramMap.get('id');

    this.VariableParametrica = new VarParamI;
    this.api.getVarParamById(VarParamId).subscribe(variable=>{
      console.log(variable);
      this.VariableParametrica = variable;
    });

    this.Superintendencia = new SuperI;
    this.SuperEditar = new SuperI;
    this.NuevaSuper = false;
    this.api.getAllSuper().subscribe(data=>{
      this.SuperinList = data;
    });
  }

  Regresar(){
    this.router.navigate(['parametricas']);
  }

  NuevaSuperintendencia(){
    this.NuevaSuper = true;
    this.NuevaSuperCod.enable();
    this.NuevaSuperNom.enable();
  }

  Guardar(){
    if(this.NuevaSuperCod.value==''){
      this.toastr.warning('Debe ingresar el codigo.', 'Advertencia!');
      this.ngOnInit();
    } else if(this.NuevaSuperNom.value==''){
      this.toastr.warning('Debe ingresar el nombre.', 'Advertencia!');
      this.ngOnInit();
    } else {
      this.Superintendencia.codigo = this.NuevaSuperCod.value;
      this.Superintendencia.nombre = this.NuevaSuperNom.value;
      /*this.api.nuevaSuperintendencia(this.Superintendencia).subscribe(result1=>{
        if(result1){
          this.toastr.success('Superintendencia creada.', 'OK!');
          this.ngOnInit();
        }
      }, error =>{
        this.toastr.error('Error al guardar.', 'Error!');
      });*/
    }
  }

  editarSuper(Super){
    this.SuperEditar.id = Super.id;
    this.SuperEditar.codigo = Super.codigo;
    this.SuperEditar.nombre = Super.nombre;
  }

  guardarSuperEditada(){
    /*this.api.nuevaSuperintendencia(this.SuperEditar).subscribe(result2=>{
      if(result2){
        this.toastr.success('Superintendencia editada.', 'OK!');
        this.ngOnInit();
      }
    }, error =>{
      this.toastr.error('Error al editar.', 'Error!');
    });*/
  }
}
